<template>
	<c-dialog ref="dialog" width="900" height="600" enable-flex @resolve="submitHandle">
		<!-- 产品信息 -->
		<div class="m-shelf-info flex">
			<p class="flex-grow ellipsis m-product-label">产品信息：<span class="m-product-name">{{productInfo}}</span><span v-if="productCode" class="m-product-code">&nbsp;&nbsp;背贴码：{{productCode}}</span></p>
			<p class="m-cost-price">成本价：<span>{{formatPrice(costPrice)}}</span></p>
			<!-- 参考价：本商品当前在售渠道的中台报价，作新渠道定价的横向参照（无参考价不展示） -->
			<p v-if="referencePriceList.length" class="m-ref-price">
				参考价：<span class="m-ref-value">{{refPriceSummary}}</span>
				<c-tooltip width="220" position="bottom" align="start">
					<span class="m-help">?</span>
					<template #tip>
						<p v-for="(ref, i) in referencePriceList" :key="i" class="m-ref-line">{{ref.channel_name}}：{{formatPrice(ref.sale_price)}}</p>
					</template>
				</c-tooltip>
			</p>
<!--			<p v-if="hasMinPrice" class="m-cost-price m-min-price">最低控价：<span>{{formatPrice(minPrice)}}</span></p>-->
		</div>

		<!-- 渠道切换 -->
		<div class="m-channel-tabs">
			<div 
				v-for="tab in channelTypeTabs" 
				:key="tab.value"
				:class="['m-tab-item', { 'm-tab-active': channelType === tab.value }]"
				@click="switchChannelTab(tab)"
			>
				{{tab.name}}
			</div>
		</div>

		<!-- 渠道表格区 -->
		<div class="m-channel-table-area flex-column flex-grow">
			<!-- 表头工具栏 -->
			<m-operate style="border: none;">
				<div v-if="pointsWarning" class="m-toolbar-left ">
					<span class="m-warn-text">{{pointsTip}}</span>
					<c-button v-if="canRecharge" color="gray" :hollow="true" @click="recharge">充值</c-button>
				</div>
				<template #right>
					<div class="m-toolbar-right flex-center">
						<label>批量填充：</label>
						<c-input type="number" decimal="2" :range="[0, 99999999]" v-model="fillPrice" placeholder="定价" style="width: 120px;"></c-input>
						<c-button  color="gray" :hollow="true" @click="fillAllPrice">填充</c-button>
						<c-tooltip tip="填充已勾选渠道的售价（含已发布渠道，随本次上架一并同步到渠道侧）" width="200" position="top" align="end"></c-tooltip>
					</div>
				</template>
			</m-operate>
			<!-- 表格 -->
			<c-table ref="list" :data="channelList" height="grow" :paging="false" empty-text="暂无可用渠道" @dataChange="syncSelectedIds">
				<c-table-column type="selector" width="40"></c-table-column>
				<c-table-column label="上架渠道" name="channel_name" min-width="160"></c-table-column>
				<c-table-column label="渠道类型" name="biz_type_name" width="100">
					<template #default="{data}">
						<span :class="bizTypeClass(data.biz_type_name)">{{data.biz_type_name || '-'}}</span>
					</template>
				</c-table-column>
				<c-table-column label="售价" width="180">
					<template #default="{data}">
						<div class="m-shelf-price">
							<c-input type="number" decimal="2" :range="[0, 99999999]" v-model="data.sale_price" placeholder="请输入售价" :disabled="!isSelected(data.channel_id) || data.channel_publish_state == 2" append-text="元" :class="{'m-price-selected': isSelected(data.channel_id) && data.channel_publish_state != 2, 'm-price-below': isBelowMinPrice(data), 'm-price-disabled': data.channel_publish_state == 2}"></c-input>
							<!-- 已发布渠道上架不支持改价，提示用户通过改价功能操作 -->
							<p v-if="data.channel_publish_state == 2" class="m-published-tip">
								<c-tooltip tip="已发布渠道，上架不改价，售价沿用当前定价。如需调整请在商品列表通过【改价】功能操作">
									<span class="m-help">?</span>
								</c-tooltip>
								<span>已发布，不可改价</span>
							</p>
							<p v-else-if="isBelowMinPrice(data)" class="m-below-tip">{{'低于最低控价'+minPrice+'元'}}</p>
							<p class="m-settle flex">
								<span>预计结算价：{{getSettleText(data)}}</span>
								<span class="m-help-wrap">
									<c-tooltip tip="预计结算价按渠道结算规则测算，实际以结算账单为准">
										<span class="m-help">?</span>
									</c-tooltip>
								</span>
							</p>
							<p class="m-settle flex">
								<span>预计消耗同售积分：{{getPointsText(data)}}</span>
								<span class="m-help-wrap">
									<c-tooltip tip="预计消耗同售积分按渠道积分阶梯测算，实际成交后从同售积分账户扣减">
										<span class="m-help">?</span>
									</c-tooltip>
								</span>
							</p>
						</div>
					</template>
				</c-table-column>
			</c-table>
		</div>
	</c-dialog>
</template>

<script>
	import { fetchSettleConfig, calcSettlePrice } from '@/components/public/settle.js';
	import { fetchPointsConfig, calcConsumePoints } from '@/components/public/points.js';

	export default {
		name: 'saleShelfChannel',

		data() {
			return {
				channelTypeTabs: [{
					name: '靓机渠道',
					value: 2
				}, {
					name: '暗拍渠道',
					value: 1
				}],
				productId: '',
				productInfo: '',
				/**背贴码：列表行带入，渠道接口回传后以服务端值为准*/
				productCode: '',
				costPrice: '',
				/**最低控价（服务端下发，未维护控价比例时为空，不标红不提醒）*/
				minPrice: '',
				/**控价处置方式（1-严格拦截 2-仅提醒，与服务端同一取值）*/
				controlMode: 2,
				/**积分不足提示（服务端按商家账户同售积分与平台配置线判定后下发）*/
				pointsWarning: false,
				/**积分校验线（分），服务端下发，文案里的分数与后端判定值同源；0为平台未配置，不校验不出提示*/
				pointsLine: 0,
				/**积分处置方式（1-拦截上架 2-仅提醒，与控价同一取值口径）*/
				pointsMode: 2,
				currentPoints: 0,
				channelType: 2,
				channelList: [],
				fillPrice: '',
				loadingData: false,
				selectedIds: [],
				/**品牌名（区分苹果/安卓结算组，列表行带入，渠道接口回传后以服务端值为准）*/
				brandName: '',
				/**渠道结算公式集合（{channel_id: {android:[], apple:[]}}），预计结算价测算依据*/
				settleConfigMap: {},
				/**渠道积分阶梯集合（{channel_id: [{price,points}]}），预计消耗积分测算依据*/
				pointsConfigMap: {},
				/**参考价列表（本商品在售渠道的中台报价，列表行带入，作定价横向参照）*/
				referencePriceList: []
			}
		},

		computed: {
			/*********参考价区间摘要：单渠道直接显价，多渠道显最低~最高（悬浮展开逐渠道明细）**********/
			refPriceSummary() {
				var prices = (this.referencePriceList || []).map(r => parseFloat(r.sale_price)).filter(v => v > 0);
				if (!prices.length) return '-';
				var min = Math.min.apply(null, prices);
				var max = Math.max.apply(null, prices);
				return min === max ? this.formatPrice(min) : this.formatPrice(min) + '~' + this.formatPrice(max);
			},

			/*********服务端是否下发了可用的最低控价（未维护控价比例时不做任何标红提醒）**********/
			hasMinPrice() {
				return this.minPrice !== '' && this.minPrice !== null && this.minPrice !== undefined && !isNaN(parseFloat(this.minPrice));
			},

			/*********控价方式是否为严格拦截（拦截模式下前端直接挡回，不浪费一次提交）**********/
			blockMode() {
				return this.controlMode == 1;
			},

			/*********是否有积分充值权限（无权限时不出按钮，只在提示里给充值入口路径）**********/
			canRecharge() {
				return this.auth('b_points_record_recharge');
			},

			/*********积分不足是否拦截上架（拦截模式下前端先挡回，与服务端同一判定口径）**********/
			pointsBlock() {
				return this.pointsWarning && this.pointsMode == 1;
			},

			/*********积分提示文案：分数与“不可上架”的用词都随服务端配置变，端内不自己拼口径**********/
			pointsTip() {
				// 余额一并报出来：只说“不足1000分”而不说现在有多少分，商户无法判断该充多少
				const desc = '当前渠道同售积分' + this.currentPoints + '分，';
				if (this.pointsBlock) {
					return desc + '已不足' + this.pointsLine + '分，不可上架，请先充值';
				}
				return desc + '不足' + this.pointsLine + '分，可能影响后续销售，请及时充值';
			}
		},

		methods: {
			/*********打开弹框**********/
			open(data) {
				this.productId = data.id;
				this.productInfo = data.product_info || '-';
				this.productCode = data.produce_unique_code || '';
				this.costPrice = data.cost_price;
				/**列表行已带最低控价，先按行数据展示，渠道接口回来后以服务端值为准*/
				this.minPrice = data.min_price === null || data.min_price === undefined ? '' : data.min_price;
				this.channelType = 2;
				this.fillPrice = '';
				this.brandName = data.brand_name || '';
				/**参考价随列表行带入（本商品在售渠道的中台报价），无则不展示*/
				this.referencePriceList = data.reference_price_list || [];
				/**结算公式随弹框打开拉一次，总后台改配置后重开弹框即生效*/
				this.loadSettleConfig();
				this.loadPointsConfig();
				this.$refs.dialog.open({
					title: '选择上架渠道',
					buttonName: '确定'
				});
				this.loadChannelList();
			},

			/*********切换渠道类型**********/
			switchChannelTab(tab) {
				if (this.channelType === tab.value) return;
				this.channelType = tab.value;
				this.loadChannelList();
			},

			/*********加载渠道列表**********/
			loadChannelList() {
				this.loadingData = true;
				this.request({
					url: '/sale/product/shelfChannel/list',
					data: {
						product_id: this.productId,
						channel_type: this.channelType
					},
					loading: true,
					success: data => {
						this.productInfo = data.product_info || this.productInfo;
						this.productCode = data.produce_unique_code || this.productCode;
						this.brandName = data.brand_name || this.brandName;
						this.costPrice = data.cost_price;
						this.minPrice = data.min_price === null || data.min_price === undefined ? '' : data.min_price;
						this.controlMode = data.price_control_mode || 2;
						this.pointsWarning = !!data.points_warning;
						this.pointsLine = data.points_line || 0;
						this.pointsMode = data.points_mode || 2;
						this.currentPoints = data.current_points || 0;
						this.channelList = (data.channel_list || []).map(item => {
							item.selected = item.sale_price !== null && item.sale_price !== undefined && item.sale_price !== '';
							item.sale_price = item.sale_price === null || item.sale_price === undefined ? '' : item.sale_price;
							return item;
						});
						this.$nextTick(() => {
							this.loadingData = false;
						});
					}
				});
			},

			/*********同步选中ID列表**********/
			syncSelectedIds() {
				if (this.loadingData) return;
				var selectedList = this.$refs.list.getData('selected');
				this.selectedIds = selectedList.map(item => item.channel_id);
			},

			/*********判断渠道售价是否低于最低控价**********/
			isBelowMinPrice(data) {
				if (!this.hasMinPrice) return false;
				var price = parseFloat(data.sale_price);
				if (!(price > 0)) return false;
				return price < parseFloat(this.minPrice);
			},

			/*********判断是否选中**********/
			isSelected(channelId) {
				return this.selectedIds.indexOf(channelId) >= 0;
			},

			/*********渠道类型颜色样式**********/
			bizTypeClass(bizType) {
				if (!bizType) return '';
				return bizType == 'B2B' ? 'm-biz-b2b' : 'm-biz-b2c';
			},

			/*********积分充值：直接开积分充值申请弹框（同售积分账户），充值需审核，回调重拉余额与提示**********/
			recharge() {
				this.globalDialog('pointsRecharge', {
					props: {
						account_type: 4
					}
				}, () => {
					this.loadChannelList();
				});
			},

			/*********批量填充售价：填充所有已勾选且未发布的渠道售价（已发布渠道不可改价，跳过）**********/
			fillAllPrice() {
				if (this.fillPrice === '' || parseFloat(this.fillPrice) <= 0) {
					this.$message({message: '请输入要填充的售价', type: 'warn'});
					return;
				}
				var selectedList = this.$refs.list.getData('selected');
				if (!selectedList.length) {
					this.$message({message: '请先勾选要上架的渠道', type: 'warn'});
					return;
				}
				var selectedIds = selectedList.map(item => item.channel_id);
				this.channelList.forEach(item => {
					// 已发布渠道不参与填充
					if (item.channel_publish_state == 2) return;
					if (selectedIds.indexOf(item.channel_id) >= 0) {
						item.sale_price = this.fillPrice;
					}
				});
				this.$refs.list.setData(this.channelList);
				// 恢复选中状态
				this.$nextTick(() => {
					var rows = this.$refs.list.rows;
					rows.forEach(row => {
						if (selectedIds.indexOf(row.data.channel_id) >= 0) {
							row.update({ _selected: true });
						}
					});
				});
			},

			/*********格式化价格**********/
			formatPrice(price) {
				if (price === null || price === undefined || price === '') return '-';
				return '¥' + parseFloat(price).toFixed(2);
			},

			/*********加载渠道结算公式（仅用于测算展示，不参与提交校验）**********/
			loadSettleConfig() {
				this.settleConfigMap = {};
				fetchSettleConfig(this, map => {
					this.settleConfigMap = map;
				});
			},

			/*********加载渠道积分阶梯（仅用于测算展示，不参与提交校验）**********/
			loadPointsConfig() {
				this.pointsConfigMap = {};
				fetchPointsConfig(this, map => {
					this.pointsConfigMap = map;
				});
			},

			/*********该渠道当前输入售价的预计消耗积分（无阶梯或未命中档位时不给分数）**********/
			getPointsText(row) {
				var points = calcConsumePoints(this.pointsConfigMap, row.channel_id, row.sale_price);
				return points === null ? '-' : points + '分';
			},

			/*********该渠道当前输入售价的预计结算价（无公式或未命中档位时不给金额）**********/
			getSettleText(row) {
				var settle = calcSettlePrice(this.settleConfigMap, row.channel_id, this.brandName, row.sale_price);
				return settle === null ? '-' : this.formatPrice(settle);
			},

			/*********提交上架：控价与积分均为仅提醒时只确认不拦截，为拦截时前端先挡回**********/
			submitHandle(stop, next) {
				stop();
				if (this.pointsBlock) {
					this.$message({message: '渠道同售积分已不足' + this.pointsLine + '分，请先充值再上架', type: 'warn'});
					return;
				}
				var channelList = [];
				var belowCount = 0;
				this.$refs.list.getData('selected').forEach(item => {
					var salePrice = parseFloat(item.sale_price);
					if (!(salePrice > 0)) return;
					if (this.isBelowMinPrice(item)) belowCount++;
					channelList.push({
						channel_id: item.channel_id,
						sale_price: salePrice
					});
				});
				if (!channelList.length) {
					this.$message({message: '请至少勾选一个渠道并填写售价', type: 'warn'});
					return;
				}
				if (belowCount) {
					this.$confirm({
						message: '有' + belowCount + '个渠道售价低于最低控价' + this.formatPrice(this.minPrice) + '，确认继续上架？',
						buttonName: '确认上架',
						cancelButton: true,
						resolve: () => {
							this.doOnShelf(channelList, next);
						}
					});
					return;
				}
				this.doOnShelf(channelList, next);
			},

			/*********提交上架请求**********/
			doOnShelf(channelList, next) {
				this.request({
					url: '/sale/product/onShelf',
					data: {
						product_id: this.productId,
						channel_list: channelList
					},
					loading: true,
					success: (data, msg) => {
						next();
						this.showWarnResult(data, msg);
						this.$emit('resolve');
					}
				});
			},

			/*********破价放行时展示明细弹框，否则维持原提示**********/
			showWarnResult(data, msg) {
				if (data && data.price_warn_count > 0) {
					this.globalDialog('salePriceWarnResult', {
						data: data
					});
					return;
				}
				this.$message({message: msg || '上架提交成功', type: 'success'});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	::v-deep .c-dialog-body {
		padding: 0 12px;
	}

	.m-shelf-info {
		padding: 12px 15px;
		margin-bottom: 12px;
		background: #f5f7fa;
		border-radius: 4px;
		font-size: 14px;

		.m-product-label {
			color: #333;
		}

		.m-product-name {
			color: #1890ff;
		}

		/*背贴码跟在产品信息后面同段展示，按次要信息弱化，不与产品名、成本价抢视线*/
		.m-product-code {
			color: #666;
		}

		.m-cost-price {
			color: #333;

			span {
				color: #f5222d;
				font-weight: bold;
				font-size: 18px;
			}
		}

		/*最低控价只是提交前的提醒，不能与成本价抢视线，按次要信息弱化展示*/
		.m-min-price {
			color: #999;
			font-size: 12px;

			span {
				color: #999;
				font-weight: normal;
				font-size: 12px;
			}
		}

		/*参考价是定价时的横向参照，按次要信息弱化，不与成本价抢视线；? 悬浮展开逐渠道明细*/
		.m-ref-price {
			margin-left: 16px;
			color: #999;
			font-size: 12px;

			.m-ref-value {
				color: #666;
				font-weight: normal;
				font-size: 12px;
			}

			.m-help {
				display: inline-flex;
				align-items: center;
				justify-content: center;
				width: 14px;
				height: 14px;
				margin-left: 4px;
				border: 1px solid #c0c4cc;
				border-radius: 50%;
				font-size: 10px;
				color: #909399;
				cursor: pointer;
			}
		}
	}

	.m-channel-tabs {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 0;
		margin: 0 auto 12px;
		padding: 4px;
		width: 320px;
		background: linear-gradient(135deg, #e6f7ff 0%, #f0f5ff 100%);
		border-radius: 24px;
		border: 1px solid #bae0ff;

		.m-tab-item {
			flex: 1;
			padding: 10px 32px;
			text-align: center;
			font-size: 14px;
			color: #666;
			cursor: pointer;
			border-radius: 20px;
			transition: all 0.3s;
			user-select: none;

			&:hover:not(.m-tab-active) {
				color: #1890ff;
			}

			&.m-tab-active {
				background: linear-gradient(135deg, #1890ff 0%, #40a9ff 100%);
				color: #fff;
				font-weight: 500;
				box-shadow: 0 2px 8px rgba(24, 144, 255, 0.3);
			}
		}
	}

	.m-channel-table-area {
		margin: 10px 20px;
		border: 1px solid #e8e8e8;
		border-radius: 4px;
		overflow: hidden;

		::v-deep .c-table-body table tbody tr {
			&.is-selected {
				background-color: #fffbe6 !important;
			}
		}
	}

	.m-table-toolbar {
		box-sizing: border-box;
		width: 100%;
		padding: 2px 10px;
		background: #fafafa;
		justify-content: space-between;
	}

	.m-toolbar-left {
		flex: 1;
		gap: 8px;

		.m-warn-text {
			padding-right: 8px;
			font-size: 13px;
			color: #f5222d;
		}
	}

	.m-toolbar-right {
		gap: 6px;

		label {
			font-size: 13px;
			color: #666;
		}
	}

	.m-shelf-price {
		.m-price-selected {
			::v-deep input {
				background-color: #fffbe6 !important;
				border-color: #ffe58f !important;
			}
		}

		// 已发布渠道售价禁用态（灰色背景，不可编辑）
		.m-price-disabled {
			::v-deep input {
				background-color: #f5f5f5 !important;
				color: #999;
				cursor: not-allowed;
			}
		}

		// 低于最低控价的售价：只标红不阻断，是否允许提交由控价方式决定
		.m-price-below {
			::v-deep input {
				border-color: #ed3f14 !important;
			}
		}

		.m-below-tip {
			margin-top: 2px;
			font-size: 12px;
			line-height: 1.4;
			color: #ed3f14;
		}

		.m-published-tip {
			margin-top: 2px;
			font-size: 12px;
			line-height: 1.4;
			color: #909399;
			display: flex;
			align-items: center;
			gap: 4px;
		}

		/*预计结算价只是测算参考，按次要信息弱化，不与售价输入框抢视线*/
		.m-settle {
			margin-top: 2px;
			font-size: 12px;
			line-height: 1.4;
			color: #999;
		}

		.m-help-wrap {
			display: inline-flex;
			align-items: center;
			flex-shrink: 0;
		}

		.m-help {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: 14px;
			height: 14px;
			margin-left: 4px;
			border: 1px solid #c0c4cc;
			border-radius: 50%;
			font-size: 10px;
			color: #909399;
			cursor: pointer;
		}
	}

	.m-biz-b2b {
		color: #666;
	}
	.m-biz-b2c {
		color: #fa8c16;
	}

	/*参考价悬浮层逐渠道行（c-tooltip 内容不属 scoped 域，行高拉开一点更易读）*/
	.m-ref-line {
		line-height: 1.8;
	}
</style>
